"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rules = void 0;
const errors_1 = require("./errors");
const regularExpressions_1 = require("./regularExpressions");
exports.rules = {
    required(value) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!value) {
                throw (0, errors_1.getErrorMessage)("required");
            }
        });
    },
    username(value) {
        return __awaiter(this, void 0, void 0, function* () {
            const { username, astralSymbols } = regularExpressions_1.regularExpressions;
            const normalizedValue = value.replace(astralSymbols, "_").trim();
            if (!username.test(normalizedValue)) {
                throw (0, errors_1.getErrorMessage)("username");
            }
        });
    },
    email(value) {
        return __awaiter(this, void 0, void 0, function* () {
            const { email } = regularExpressions_1.regularExpressions;
            const normalizedValue = value.toLowerCase();
            if (!email.test(normalizedValue)) {
                throw (0, errors_1.getErrorMessage)("email");
            }
        });
    },
    emailStrong(value) {
        return __awaiter(this, void 0, void 0, function* () {
            const { emailStrong } = regularExpressions_1.regularExpressions;
            const normalizedValue = value.toLowerCase();
            if (!emailStrong.test(normalizedValue)) {
                throw (0, errors_1.getErrorMessage)("email");
            }
        });
    },
    password(value) {
        return __awaiter(this, void 0, void 0, function* () {
            const { password } = regularExpressions_1.regularExpressions;
            if (!password.test(value)) {
                throw (0, errors_1.getErrorMessage)("password");
            }
        });
    },
    contactNumber(value) {
        return __awaiter(this, void 0, void 0, function* () {
            const { contactNumber } = regularExpressions_1.regularExpressions;
            const normalizedValue = value.toLowerCase();
            if (!contactNumber.test(normalizedValue)) {
                throw (0, errors_1.getErrorMessage)("contactNumber");
            }
        });
    },
    website(value) {
        return __awaiter(this, void 0, void 0, function* () {
            const { website } = regularExpressions_1.regularExpressions;
            const normalizedValue = value.toLowerCase();
            if (!website.test(normalizedValue)) {
                throw (0, errors_1.getErrorMessage)("website");
            }
        });
    },
};
//# sourceMappingURL=rules.js.map